<ion-grid>
	<ion-row>
		<ion-col>
			<ion-grid class="max-w-1336" *ngIf="jobfairList$ | async as employees">
				<ng-container *ngIf="employees.isSkeleton">
					<ion-grid class="side-menu-wrapper text-center">
						<ion-spinner class="ion-spinner"></ion-spinner>
					</ion-grid>
				</ng-container>
				<ion-row *ngIf="employees.data.data">
					<ion-col col="12">
						<dx-data-grid
							id="gridContainer"
							[dataSource]="employees.data.data"
							keyExpr="id"
							[allowColumnResizing]="true"
							[columnAutoWidth]="true"
							[showBorders]="true"
						>
							<dxo-search-panel
								[visible]="true"
								[width]="240"
								placeholder="Search..."
							></dxo-search-panel>
							<dxo-header-filter
								[visible]="showHeaderFilter"
							></dxo-header-filter>
							<dxo-column-chooser
								[enabled]="true"
								mode="select"
							></dxo-column-chooser>
							<dxo-column-fixing [enabled]="true"></dxo-column-fixing>
							<dxi-column
								caption="Actions"
								dataField="id"
								[allowFiltering]="false"
								[allowSorting]="false"
								cellTemplate="cellTemplate"
								[width]="150"
								[fixed]="true"
							>
							</dxi-column>
							<dxi-column
								dataField="title"
								caption="Title"
								[width]="230"
								[fixed]="true"
							></dxi-column>
							<dxi-column
								dataField="name"
								caption="Typeform Title"
								[width]="230"
								[visible]="false"
							></dxi-column>
							<dxi-column
								dataField="notificationTitle"
								caption="Notification Title"
								[width]="230"
								[visible]="false"
							></dxi-column>
							<dxi-column
								dataField="notificationTitle1"
								caption="Notification Sub Title"
								[visible]="false"
								[width]="230"
							></dxi-column>
							<dxi-column
								dataField="description"
								caption="Description"
								[width]="230"
							></dxi-column>
							<dxi-column
								dataField="canJoin"
								caption="Who Can Join"
								[visible]="false"
							></dxi-column>
							<dxi-column
								dataField="jobFairDate"
								caption="Start Date"
								dataType="datetime"
								format="dd/MM/yyyy hh:mm aa"
							></dxi-column>
							<dxi-column
								dataField="endDate"
								caption="End Date"
								dataType="datetime"
								format="dd/MM/yyyy hh:mm aa"
							></dxi-column>
							<dxi-column
								dataField="eventUrl"
								caption="Event Link"
							></dxi-column>
							<dxi-column
								dataField="visible"
								caption="Visible"
								[visible]="false"
							></dxi-column>
							<dxi-column
								dataField="isEpp"
								caption="isEpp"
								[visible]="false"
							></dxi-column>
							<dxi-column
								dataField="enableNotification"
								caption="Enable Notification"
								[visible]="false"
							></dxi-column>
							<dxi-column
								dataField="scheduleFinalised"
								caption="Schedule Finalised"
								[visible]="false"
							></dxi-column>
							<dxi-column
								dataField="typeForm"
								caption="TypeForm Link"
								[visible]="false"
							></dxi-column>
							<dxi-column
								dataField="slotSelectionLink"
								caption="Slot Selection Link"
								[visible]="false"
							></dxi-column>
							<div *dxTemplate="let d of 'cellTemplate'">
								<a (click)="editInfo(d.data)" class="cursor">Edit</a> /
								<a (click)="viewInfo(d.data.id)" class="cursor">View</a>
							</div>
							<dxo-toolbar>
								<dxi-item location="before">
									<div *dxTemplate class="informer">
										<ion-button (click)="addJobfair()"
											><ion-icon name="add-outline"></ion-icon
										></ion-button>
									</div>
								</dxi-item>
								<dxi-item location="before">
									<div *dxTemplate class="informer">
										<p class="Heading_M">Add New Jobfair</p>
									</div>
								</dxi-item>
								<dxi-item name="columnChooserButton"></dxi-item>
								<dxi-item name="searchPanel"></dxi-item>
							</dxo-toolbar>
						</dx-data-grid>
					</ion-col>
				</ion-row>
			</ion-grid>
		</ion-col>
	</ion-row>
</ion-grid>
